import React from "react";
import assetimages from "./common/assetimages";
import { Link } from "react-router-dom";
import { errorToast, successToast } from "./common/showtoast";
import ApiRequest from "./common/restservice";
export default class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
    };
  }
  async firstLogin(token) {
    let response = await ApiRequest("update_firstlogin.asp", "GET", null, {
      Authorization: token,
    });
    console.log(response);
  }
  render() {
    return (
      <div
        style={{
          background: `url(${assetimages.bg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <div className="d-flex align-items-center min-vh-100 py-3 py-md-0">
          <div className="container">
            <div
              className="card login-card col-lg-6 mx-auto"
              style={{ backgroundColor: "#f1fff0f2" }}
            >
              <div className="card-body">
                <div className="brand-wrapper text-center">
                  <img src={assetimages.logo} style={{height:100}} alt="logo" className="logo" />
                </div>
                <p className="login-card-description">
                  Enter your credentials to access your account
                </p>
                {/* <div className="user mb-2">
                                        <ul>
                                            <li><img src={assetimages.metamask}  alt="Metamask"/></li>
                                            <li><img src={assetimages.trustwallet}  alt="Trustwallet"/></li>
                                            <li><img src={assetimages.imtoken}  alt="ImToken"/></li>
                                            <li><img src={assetimages.coinbase}  alt="Coinbase"/></li>
                                        </ul>
                                    </div> */}
                <form
                  onSubmit={async (e) => {
                    e.preventDefault();
                    if (!this.state.username) {
                      errorToast("Enter valid username");
                      return;
                    } else if (!this.state.password) {
                      errorToast("Enter valid password");
                      return;
                    }
                    let jsoninput = {
                      username: this.state.username,
                      password: this.state.password,
                    };
                    let res = await ApiRequest(
                      "MemberLoginMobile.asp",
                      "POST",
                      jsoninput
                    );
                    if (res.status === "error") {
                      errorToast(res.message);
                      return;
                    }
                    successToast(res.message);
                    localStorage.setItem("username", this.state.username);
                    localStorage.setItem("token", res.token);
                    this.props.history.push("/home");
                  }}
                >
                  <div className="form-group">
                    <label htmlFor="username" className="sr-only">
                      Username
                    </label>
                    <input
                      type="text"
                      name="username"
                      id="username"
                      className="form-control"
                      placeholder="Username"
                      onChange={(e) => {
                        this.setState({
                          username: e.target.value,
                        });
                      }}
                      value={this.state.username}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="password" className="sr-only">
                      Password
                    </label>
                    <input
                      type="password"
                      name="password"
                      id="password"
                      className="form-control"
                      placeholder="Password"
                      onChange={(e) => {
                        this.setState({
                          password: e.target.value,
                        });
                      }}
                      value={this.state.password}
                    />
                  </div>

                  <input
                    name="login"
                    id="login"
                    className="btn btn-block login-btn mb-4"
                    type="submit"
                    value="Login"
                  />
                </form>
                <p className="login-card-footer-text">
                  
                  <Link to="/forgotpassword" className="text-reset">
                    Forgot Password?
                  </Link>
                </p>
                <p className="login-card-footer-text">
                  Don&apos;t have an account?
                  <Link to="/register" className="text-reset">
                    Register here
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
